import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Switch, useRouteMatch } from 'react-router';
import { Grid } from '@material-ui/core';
import { getUserRequest } from '../../store/modules/users/actions';
import { selectUser } from '../../store/modules/users/selectors';
import { ViewFrame } from '../../components';
import SideTabs from '../../components/side-tabs/SideTabs';
import TabRedirect from '../../components/tab-redirect/TabRedirect';
import UserProfile from './tab-profile/UserProfile';
import UserBilling from './tab-billing/UserBilling';
import AdjustmentsButtonGroup from './AdjustmentsButtonGroup/AdjustmentsButtonGroup';
import { useGuard } from '../../hooks';
import { is, roles } from '../../utility/guard';
import InvoiceCreate from '../billing/Invoices/InvoiceCreate';

const User = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const { params: { id: userId } } = useRouteMatch<{ id: string }>();
  const { path } = useRouteMatch();
  const isSuperAdmin = useGuard(is(roles.superAdmin));
  const showAdjustmentCreditsPanel = isSuperAdmin && path.search('billing/credit-history') !== -1;
  const isNewUser = userId ? userId === 'new' : false;
  const showInvoicePanel = isSuperAdmin && path.search('billing/invoices') !== -1;

  useEffect(() => {
    if (userId && userId !== 'new') {
      dispatch(getUserRequest(Number(userId)));
    }
  }, [userId, dispatch, isNewUser]);


  return (
    <ViewFrame
      title={user && user.data && user.data.ref.full_name_first_last}
      backToListLink
      actionPanel={(
        <>
          {user.data && showAdjustmentCreditsPanel && <AdjustmentsButtonGroup user={user.data} />}
          {user.data && showInvoicePanel && (<InvoiceCreate userId={user.data!.id} />)}
        </>
      )}
    >
      <TabRedirect />
      <Grid container spacing={1}>
        <Grid item lg={2} xs={12}>
          {!user.loading && (<SideTabs variant="users" />)}
        </Grid>
        <Grid item xs={12} lg={10}>
          <Switch>
            <Route>
              <UserProfile isNewUser={isNewUser} />
              {!isNewUser && <UserBilling />}

            </Route>
          </Switch>
        </Grid>
      </Grid>
    </ViewFrame>
  );
};

export default User;
